export const actionTypes = Object.freeze({
  Amend: 1,
  Discussion: 2,
  ViewAmend: 3,
  ReplaceDiscussion: 4,
  History: 5,
  ModifyDiscussionDate: 6,
});
